import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Checkbox: ComponentStyleConfig = {
  baseStyle: {
    control: {
      bg: 'white',
      _checked: {
        bg: '#FFFFFF',
        borderColor: '#C8C6D0',
        color: '#29CC97',
        _hover: {
          bg: '#FFFFFF',
          borderColor: '#C8C6D0',
        },
      },
    },
  },
  sizes: {
    xl: { control: { w: 6, h: 6 } },
  },
  variants: {
    grayBorder: {
      control: {
        bg: 'white',
        borderColor: '#C8C6D0',
        _checked: {
          bg: '#FFFFFF',
          borderColor: '#C8C6D0',
          color: '#29CC97',
          _hover: {
            bg: '#FFFFFF',
            borderColor: '#C8C6D0',
          },
        },
        _disabled: {
          bg: '#C8C6D0',
        },
      },
    },
  },
  defaultProps: {},
};

export default Checkbox;
